
<script>
import Vue from 'vue'
import VueSession from 'vue-session'

Vue.use(VueSession)

export default {
  name: 'countdown',
    props:['time'],
    data() {
        return {
            seconds:null,
            minutes:null,
            hours:null,
            days:null,
            timesup:false
        }
    },
    watch: { 
      time: function(newVal, oldVal) { 
       this.processDateInput();
       this.timesup = false;
      }
    },
    methods:{
       processDateInput(){
          if(this.time){
              let timeList = this.time.split(':');
              this.hours = parseInt(timeList[0]);
              this.minutes = parseInt(timeList[1]);
              this.seconds = parseInt(timeList[2]);
              this.timesup = false;
          }
       }
    },
    created() {
        this.processDateInput();
        setInterval(() => {
              if(this.seconds==0){
                if(this.minutes==0){
                  if(this.hours>0){
                      this.hours--;
                      this.minutes=60;
                      this.minutes--;
                  } 
                }else{
                  this.minutes--;
                  this.seconds=60;
                  this.seconds--;
                }
              }else{
                this.seconds--;
              }
              if(!this.timesup){
                if(this.hours==0&&this.minutes==0&&this.seconds==0){
                    this.timesup = true;
                    this.$emit('timesup', true);
                }
              } 
        },1000);
    },

    filters: {
      two_digits: function (value) {
        if(value != undefined && value != null){
             if(value.toString().length <= 1)
              {
                  return "0"+value.toString();
              }
              return value.toString();
        }
        return value;
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/shared/countdown/Countdown.vue